import { render } from "./CoffeeBreakT3.vue?vue&type=template&id=55b7b7c1"
import script from "./CoffeeBreakT3.vue?vue&type=script&lang=js"
export * from "./CoffeeBreakT3.vue?vue&type=script&lang=js"

import "../css/buffet.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__